

















import Vue from 'vue';
import { Component, Prop, InjectReactive } from 'vue-property-decorator';
import { CourseData } from 'frontend/components/search/types';
import { track } from 'frontend/utils/analytics';
import { dumbSlugifySearchQuery } from 'frontend/utils/formatting';

@Component
export default class CourseSearchCards extends Vue {
  @Prop(Array) readonly courses!: CourseData[];
  @Prop(String) readonly queryID!: string;
  @Prop(Number) readonly startPosition!: number;
  @InjectReactive() readonly searchQuery!: string;

  private clickAction: string = 'clicked_course_card';

  private getPosition(index: number): number {
    return this.startPosition + index;
  }

  private getSearchEventDetails(courseData: CourseData, index: number) {
    return {
      query_id: this.queryID,
      action: this.clickAction,
      course_id: courseData.id,
      lesson_id: null,
      course_search_position: this.getPosition(index),
      lesson_search_position: null,
      query: dumbSlugifySearchQuery(this.searchQuery),
    };
  }

  private sendSearchClickEvent(courseData: CourseData, index: number) {
    track('course_search_event', this.getSearchEventDetails(courseData, index), {});
  }
}
